import React, { useEffect, useRef, useState, useCallback } from 'react';
import PhoneTracker from './phoneTracker';

const DynamicMap = () => {
  const mapRef = useRef(null);
  const [userLocation, setUserLocation] = useState(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [loadError, setLoadError] = useState(null);
  const [mapInstance, setMapInstance] = useState(null);

  // Use your actual API key
  const GOOGLE_MAPS_API_KEY = 'AIzaSyCPzpWYTXiLoAd21_JOuV1mPa74ivYbEZo'; // Replace with your key

  // 1. Effect to get user location (runs once)
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
        },
        (error) => {
          console.error('Error fetching location:', error);
          setUserLocation({ lat: 6.5244, lng: 3.3792 }); // Fallback to Lagos
        }
      );
    } else {
      setUserLocation({ lat: 6.5244, lng: 3.3792 });
    }
  }, []);

  // 2. Effect to load Google Maps script (runs when userLocation is available)
  useEffect(() => {
    if (!userLocation || mapLoaded) return;

    const scriptId = 'google-maps-script';

    const initMap = () => {
      if (mapRef.current && window.google) {
        try {
          const map = new window.google.maps.Map(mapRef.current, {
            center: userLocation,
            zoom: 15,
            mapTypeId: 'roadmap',
          });

          new window.google.maps.Marker({
            position: userLocation,
            map: map,
            title: 'Your Location',
          });

          setMapInstance(map);
          setMapLoaded(true);
        } catch (err) {
          setLoadError('Failed to initialize map.');
          console.error('Map init error:', err);
        }
      }
    };

    const loadScript = () => {
      // Remove existing script with the same ID to prevent duplicates
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }

      const script = document.createElement('script');
      script.id = scriptId;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&loading=async&callback=initMap`;
      script.async = true;
      script.defer = true;

      script.onload = () => console.log('Maps script loaded successfully.');
      script.onerror = () => {
        setLoadError('Failed to load Google Maps script. Check your API key and network.');
        console.error('Maps script load error.');
      };

      document.head.appendChild(script);
    };

    // Attach callback to window *before* loading script
    window.initMap = initMap;

    loadScript();

    // Cleanup function: remove the script tag and the callback
    return () => {
      const script = document.getElementById(scriptId);
      if (script) {
        script.remove();
      }
      delete window.initMap;
    };
  }, [userLocation, mapLoaded]);

  if (loadError) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>
        <h3>Map Error</h3>
        <p>{loadError}</p>
        <p>Please check the browser console for more details.</p>
      </div>
    );
  }

  if (!userLocation) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Getting your location...</div>;
  }

  return (
    <div style={{ padding: '20px' }}>
      <h1>Phone Tracking Map</h1>
      <div
        id="map"
        ref={mapRef}
        style={{
          width: '100%',
          height: '500px',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        }}
      />
      <PhoneTracker />
    </div>
  );
};

export default DynamicMap;